import { getENV } from '@libs/common-next';

import { useQueryProductX } from './useQueryProductX';
import { useQueryTailored } from './useQueryTailoredX';

export const useProduct = () => {
    const locale = getENV('NEXT_PUBLIC_LOCALE');

    // Base product from the query
    const { base, product } = useQueryProductX({ locale });
    const productDeliveryMethodsList = product?.deliveryMethodsList ?? [];

    // Tailored product from the query
    const tailored = useQueryTailored({
        locale,
        variantSkus: base?.variantsSkus ?? [],
        deliveryMethodsList: productDeliveryMethodsList,
    });

    // Loading state
    const isLoadingState = tailored.isLoading || tailored.isPending;
    const isLoadingData = product ? Boolean(productDeliveryMethodsList.length) && isLoadingState : isLoadingState;

    return {
        base,
        product,
        tailored: tailored.data,
        isFetching: tailored.isFetching,
        isLoading: isLoadingData,
        isError: tailored.isError,
        error: tailored.error,
    };
};
